<template>
  <div id="video">
    <div class="firstPart">
      <div class="topPart">
        <h2 class="title">视频识别</h2>
      </div>
      <div class="middlePart">
        <div class="imgBox">
          <img src="../../../assets/img/product/zhuji.svg" alt="" />
        </div>
        <div class="rightBox">
          <div class="videoDesc">
            采用AI属于建模算法，对视频图像进行分析，提取关键事件报警并推送给智慧消防系统，支持按摄像头针对性再训练。采用AI属于建模算法，对视频图像进行分析，提取关键事件报警并推送给智慧消防系统，支持按摄像头针对性再训练。
          </div>
        </div>
        <div class="phoneShow">
          <img src="../../../assets/img/product/zhuji.svg" alt="" />
          <div class="videoName">视频 AI分析器</div>
          <div class="videoDesc">
            采用AI属于建模算法，对视频图像进行分析，提取关键事件报警并推送给智慧消防系统，支持按摄像头针对性再训练。采用AI属于建模算法，对视频图像进行分析，提取关键事件报警并推送给智慧消防系统，支持按摄像头针对性再训练。
          </div>
        </div>
      </div>
      <el-row :gutter="30" class="endPart">
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" align="center">
          <div class="videoPanel wow animate__zoomIn">
            <img src="../../../assets/img/product/yanhuo.svg" alt="" class="bg1" />
            <div class="videoPanelName">烟火识别</div>
            <div class="videoPanelDesc">
              识别是否存在起烟起火情况，适用于开放大空间区域 
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" align="center">
          <div class="videoPanel wow animate__zoomIn">
            <img src="../../../assets/img/product/ruqin.svg" alt="" class="bg2" />
            <div class="videoPanelName">入侵监测</div>
            <div class="videoPanelDesc">
              识别是否存在人员，适用于无人值守、禁止入内区域
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" align="center">
          <div class="videoPanel wow animate__zoomIn">
            <img src="../../../assets/img/product/zuse.svg" alt="" class="bg3" />
            <div class="videoPanelName">空间阻塞</div>
            <div class="videoPanelDesc">
              识别消防通道、重点区域是否存在占用情况
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" align="center">
          <div class="videoPanel wow animate__zoomIn">
            <img src="../../../assets/img/product/zhishou.svg" alt="" class="bg4" />
            <div class="videoPanelName">值守在岗</div>
            <div class="videoPanelDesc">
              识别消控室、重点岗位值守人员是否出现脱岗情况
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="lastPart">
      <div class="content">
        视频烟火分析
      </div>
      <div class="videoBox">
        <video src="../../../assets/img/product/demoVidep.mp4" class="videos" controls="controls"></video>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
export default {
  props: {},
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {
   new WOW({ live: false}).init();
  },
  watch: {},
  methods: {},
  components: {},
};
</script>

<style scoped lang="scss">
#video {
  .topPart {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 3rem;
    .title {
      font-size: 2.6rem;
      color: #333333;
    }
    .line {
      width: 16rem;
      border-bottom: 0.2rem solid #535353;
      margin: 2rem 0 1.4rem;
    }
    .intro {
      width: 70%;
      color: #999999;
      font-size: 1.4rem;
      line-height: 2.2rem;
    //   text-align: justify;
    //   text-justify: inter-ideograph; /*IE*/
    }
  }
  .firstPart {
    padding: 5% 14%;
    .middlePart {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: 16rem;
      box-shadow: 0px 25px 92px 0px rgba(194, 194, 194, 0.16);
      border-radius: 10px;
      margin-bottom: 10rem;
      .imgBox {
        height: 100%;
        width: 16rem;
        background: #1cbda5;
        border-radius: 10px 0 0 10px;
        text-align: center;
        padding: 1rem;
        img {
          width: 13rem;
          height: 10rem;
          margin-top: calc((100% - 100px) / 1.5);
        }
      }
      .rightBox {
        padding: 3rem;
        .videoDesc {
          font-size: 1.4rem;
          color: #696969;
          line-height: 2.6rem;
          text-justify: inter-ideograph;
          text-align: justify;
        }
      }
      .phoneShow {
        padding: 2rem;
        height: 100%;
        width: 100%;
        margin: 3rem 0;
        display: none;
        text-align: center;
        img {
          width: 8rem;
          height: 8rem;
          object-fit: contain;
        }
        .videoName {
          font-size: 1.6rem;
          color: #333333;
          line-height: 4.2rem;
          margin: 2rem 0 1rem;
        }
        .videoDesc {
          font-size: 1.4rem;
          color: #696969;
          line-height: 2.6rem;
          text-align: left;
        }
      }
    }
    
    .endPart {
      display: flex;
      justify-content: space-evenly;
      flex-wrap: wrap;
      align-items: center;
      .videoPanel {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 3rem;
        box-shadow: 0px 7px 70px 0px rgba(201, 217, 222, 0.39);
        border-radius: 4px;
        cursor: pointer;
        height: 20rem;
        margin-top: 5rem;
        &:hover {
          box-shadow: 0px 1rem 2rem 0px rgba(48, 55, 66, 0.15);
          transform: translate(0, -5px);
          transition: all 0.3s;
        }
        img {
          border-radius: 50%;
          width: 5rem;
          height: 5rem;
          position: absolute;
          top: -2.5rem;
        }
        
        .videoPanelName {
          font-size: 1.6rem;
          color: #333333;
          line-height: 4.2rem;
        }
        .videoPanelDesc {
          font-size: 1.4rem;
          color: #777777;
          line-height: 2.2rem;
          margin-top: 1rem;
          text-align: left;
        }
      }
    }
  }
  .lastPart {
    padding: 5% 0%;
    .content {
      font-size: 2.8rem;
      color: #333333;
      line-height:3rem;
      width: 100%;
      text-align: center;
      margin-bottom: 3rem;
    }
    .videoBox {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 3% 0;
      position: relative;
      background-image: url("../../../assets/img/product/videoBg.png");
      background-position: center;
      background-size: 100% 100%;
      margin-top: 4rem;
      background-repeat: no-repeat;
      .videos{
        height: 30rem;
      }
    }
    
  }
}
@import '../../../assets/responsive/video.scss'
</style>
